import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  fullWidth?: boolean;
  href?: string;
}
export function CTAButton({
  children,
  className = '',
  onClick,
  fullWidth = false,
  href
}: CTAButtonProps) {
  const baseClassName = `
    bg-[#7C3AED] hover:bg-[#6D28D9] text-white font-bold uppercase tracking-wide
    py-4 px-8 rounded-full shadow-lg hover:shadow-xl transition-all duration-300
    flex items-center justify-center gap-2 text-lg
    ${fullWidth ? 'w-full' : ''}
    ${className}
  `;
  if (href) {
    return <motion.a href={href} target="_blank" rel="noopener noreferrer" whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={baseClassName} data-id="element-223">
        {children}
        <ArrowRight className="w-5 h-5" data-id="element-224" />
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick} className={baseClassName} data-id="element-225">
      {children}
      <ArrowRight className="w-5 h-5" data-id="element-226" />
    </motion.button>;
}